import { useSyncExternalStore } from 'use-sync-external-store/shim/index.js';

function subscribe(callback) {
  window.addEventListener("blur", callback);
  window.addEventListener("focus", callback);
  return () => {
    window.removeEventListener("blur", callback);
    window.removeEventListener("focus", callback);
  };
}
function getSnapshot() {
  return document.hasFocus();
}
function getServerSnapshot() {
  return true;
}
function useWindowFocus() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

export { useWindowFocus };
//# sourceMappingURL=use-window-focus.mjs.map
